import React, { useEffect, useState } from 'react';
import { PageHeader, Row, Col, Form, Input, InputNumber, Button, Divider, Select, Upload, message,Switch } from 'antd';
import { UploadOutlined } from "@ant-design/icons";
import { useStore } from '../../context/store';
import { observer } from 'mobx-react-lite';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const URL = "https://api.rr-healthcare.com/api/v1";

function AddProduct() {
    const { Option } = Select;
    const { productStore, categoryStore } = useStore();
    const adminToken = window.localStorage.getItem('adminToken') 
    const authorization = { Authorization: `Bearer ${adminToken}` }

    const Tech = "<figure class=\"table\"><table><thead><tr><th>SPECIFICATION</th><th>&nbsp;</th><th>Extra-Small</th><th>Small</th><th>Medium</th><th>Large</th><th>Extra-Large</th><th>Tolerance</th></tr></thead><tbody><tr><td>Total Length (mm)</td><td>&nbsp;</td><td>240</td><td>240</td><td>240</td><td>240</td><td>240</td><td>+/- 5</td></tr><tr><td>Width of Palm (mm)</td><td>&nbsp;</td><td>75</td><td>85</td><td>95</td><td>105</td><td>115</td><td>+/- 5</td></tr><tr><td>Width of Cuff (mm)</td><td>&nbsp;</td><td>85</td><td>90</td><td>95</td><td>100</td><td>105</td><td>+/- 5</td></tr><tr><td>Thickness (mm)</td><td>Finger</td><td>0.08</td><td>0.08</td><td>0.08</td><td>0.08</td><td>0.08</td><td>Min</td></tr><tr><td>&nbsp;</td><td>Palm</td><td>0.06</td><td>0.06</td><td>0.06</td><td>0.06</td><td>0.06</td><td>Min</td></tr><tr><td>&nbsp;</td><td>Cuff</td><td>0.05</td><td>0.05</td><td>0.05</td><td>0.05</td><td>0.05</td><td>Min</td></tr><tr><td>Weight per pc</td><td>(gram)</td><td>2.7</td><td>3.1</td><td>3.5</td><td>3.9</td><td>4.3</td><td>+/- 0.3</td></tr><tr><td>Palm Thickness</td><td>(mils)</td><td>2.5</td><td>2.5</td><td>2.5</td><td>2.5</td><td>2.5</td><td>Min</td></tr><tr><td>Tensile Strength</td><td>(&gt;) min</td><td>14 Mpa</td><td>14 Mpa</td><td>14 Mpa</td><td>14 Mpa</td><td>14 Mpa</td><td>Min</td></tr><tr><td>Elongation</td><td>Before ageing</td><td>500</td><td>500</td><td>500</td><td>500</td><td>500</td><td>Min</td></tr><tr><td>(% min)</td><td>After ageing</td><td>400</td><td>400</td><td>400</td><td>400</td><td>400</td><td>Min</td></tr></tbody></table></figure>"
    const over = "<p>Nitrile Medical Examination Gloves</p><ul><li>With multi-purpose capability for healthcare, dentistry, sanitation, light industry and food processing</li><li>Fine-gauge for extra sensitivity and feel</li><li>Ambidextrous, Textured Finger and beaded Cuff with 5-year shelf-life</li><li>Non-sterile single-use disposable, 100% Powder and Latex-free</li></ul><p>Key Standards: CE; EN21420; EN455; EN374, EN1186</p>"
    const desc = "<figure class=\"table\"><table><tbody><tr><td colspan=\"2\">Nitrile Powder-free Disposable Examination Gloves</td></tr><tr><td>Material</td><td>Nitrile (100% Latex-free)</td></tr><tr><td>Length</td><td>240mm</td></tr><tr><td>Thickness</td><td>Finger 0.08mm; Palm 0.06mm</td></tr><tr><td>Weight</td><td>3.5g size M</td></tr><tr><td>Glove Design</td><td>Medical Grade</td></tr><tr><td>&nbsp;</td><td>Healthcare, Dental, Beauty, Sanitation, Light Industrial and Food Processing applications</td></tr><tr><td>&nbsp;</td><td>Fine-gauge for extra feel and sensitivity</td></tr><tr><td>&nbsp;</td><td>Textured Finger &amp; Beaded Cuff</td></tr><tr><td>Color</td><td>Light Blue</td></tr><tr><td>Packaging</td><td>100 pieces per box; 10 boxes per carton</td></tr></tbody></table></figure>"
    const cert = "<p><strong>PRO-MANUS NITRILE EXAM GLOVE CERTIFICATIONS &amp; APPROVALS&nbsp;</strong></p><p><strong>Global&nbsp;</strong></p><p>•&nbsp;<strong>ISO 9001:2015&nbsp;</strong>– International standard for Quality Management Systems&nbsp;</p><p>•&nbsp;<strong>ISO 13485:2016&nbsp;</strong>– Quality Management Systems for Medical Devices.&nbsp;</p><p>&nbsp;</p><p><strong>United States of America&nbsp;</strong></p><p>•&nbsp;<strong>FDA510K&nbsp;</strong>– Medical Device pre-market notification clearance (pre-2019)&nbsp;</p><p>•&nbsp;<strong>ASTM D6319&nbsp;</strong>– Specification for Nitrile Examination Gloves for Medical Application</p><p>&nbsp;•&nbsp;<strong>ASTM D6798&nbsp;</strong>– Assessment of Resistance of Medical Gloves to Permeation by Chemotherapy&nbsp; Drugs&nbsp;</p><p>•&nbsp;<strong>ASTM F1671&nbsp;</strong>- Resistance of Materials Used in Protective Clothing to Penetration by Blood Borne Pathogens&nbsp;</p><p>&nbsp;</p><p><strong>Europe / United Kingdom&nbsp;</strong></p><p>•&nbsp;<strong>CE&nbsp;</strong>– Certification to all applicable European health, safety, performance and environmental&nbsp; requirements&nbsp;</p><p>•&nbsp;<strong>EN21420&nbsp;</strong>– European Safety Glove standards&nbsp;</p><p>•&nbsp;<strong>EN455 parts 1-4&nbsp;</strong>– Medical Disposable Glove Standards&nbsp;</p><p>•&nbsp;<strong>EN374</strong>&nbsp;with&nbsp;<strong>EN374-1:2016</strong>&nbsp;<strong>Type B (K P T)</strong>&nbsp;and&nbsp;<strong>EN16523-1:2015</strong>&nbsp;– Protective Glove Standards against Chemicals and Micro-organisms</p><p>•&nbsp;<strong>EU Certificate and Declaration of Conformity&nbsp;</strong>for&nbsp;<strong>Class 1 MDR (EU) 2017/425&nbsp;</strong></p><p>•&nbsp;<strong>EU Certificate and Declaration of Conformity&nbsp;</strong>for&nbsp;<strong>Category III PPE (EU) 2016/425&nbsp;</strong>•&nbsp;<strong>MHRA&nbsp;</strong>– UK Medical &amp; Healthcare products Regulatory Agency&nbsp;</p><p>•&nbsp;<strong>EN1186; EC 1935/2004; EC 10/2011; GMP (EC) 2023/2006&nbsp;</strong>– Food Safety&nbsp;</p><p>&nbsp;</p><p><strong>Australasia / Pacific&nbsp;</strong></p><p>•&nbsp;<strong>TGA&nbsp;</strong>– Register of Therapeutic Goods Administration, Australia&nbsp;</p><p>•&nbsp;<strong>MOH&nbsp;</strong>– Japan Ministry of Health&nbsp;</p><p>•&nbsp;<strong>CMDCAS&nbsp;</strong>– Canadian Medical Devices Conformity Assessment System</p>"
    useEffect(() => {
        categoryStore.loadCategoryList()
    }, [])

    const [imageLists, setImageLists] = useState([]);
    const [subCategoriesData, setSubCategoriesData] = useState([{ id: "", name: "", parent: "" }])
    const [subcategoryVisible, setSubcategoryVisible] = useState(false);
    const [under_subCategoriesData, setUnder_SubCategoriesData] = useState([{ id: "", name: "", parent: "" }])
    const [under_subcategoryVisible, setUnder_SubcategoryVisible] = useState(false);
    const [overview, setOverview] = useState(null);
    const [description, setDescription] = useState(null);
    const [techspecs, setTechspecs] = useState(null);
    const [certificates, setCertificates] = useState(null);
    const [visibleXS, setVisibleXS] = useState(false);
    const [visibleS, setVisibleS] = useState(false);
    const [visibleL, setVisibleL] = useState(false);
    const [visibleXL, setVisibleXL] = useState(false);
    const [visibleM, setVisibleM] = useState(false);
    const [categoryName, setCategoryName] = useState("");

    console.log("ImageLists", imageLists)

    function uploadAdapter(loader) {
        return {
          upload: () => {
            return new Promise((resolve, reject) => {
              const body = new FormData();
              loader.file.then((file) => {
                body.append("file", file);
                // let headers = new Headers();
                // headers.append("Origin", "http://localhost:3000");
                fetch(`${URL}/auth/upload`, {
                  method: "post",
                  body: body,
                  // mode: "no-cors"
                  headers: {authorization}
                })
                  .then((res) => res.json())
                  .then((res) => {
                    console.log("res:", res)
                    resolve({
                      default: res.data.url
                    });
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
            });
          }
        };
    }
      
    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
          return uploadAdapter(loader);
        };
    }
    
    const onSelectCategory = (value, event) => {
        const subCategories = productStore.getSubCategories(value === null ? "" : value)
        if(subCategories.length !==0){
            setSubCategoriesData(subCategories.map(value => ({
                _id: value._id, 
                name: value.name,
                parent: value.parent_id._id
            })))             
            setSubcategoryVisible(true)
        }else{
            setSubcategoryVisible(false)  
        }
    }

    const onSelectSubCategory = (value, event) => {
        const under_subCategories = productStore.getSubCategories(value === null ? "" : value)
        if(under_subCategories.length !==0){
            setUnder_SubCategoriesData(under_subCategories.map(value => ({
                _id: value._id, 
                name: value.name,
                parent: value.parent_id._id
            })))             
            setUnder_SubcategoryVisible(true)
        }else{
            setUnder_SubcategoryVisible(false)  
        }
    }

    const imageProps = {
        name: "file",
        action: "https://api.rr-healthcare.com/api/v1/auth/upload",
        headers: {
          authorization: "authorization-text",
        },
        onChange(info) {
          if (info.file.status !== "uploading") {
            console.log(info.file, info.fileList);
          }
          if (info.file.status === "done") {
            message.success(`${info.file.name} file uploaded successfully`);
            setImageLists(info.fileList)
          } else if (info.file.status === "error") {
            message.error(`${info.file.name} file upload failed.`);
          }
        },
    };

    const formSubmit = (values) => {
        if(values.under_subcatId){
            productStore.createProduct({
                name: values.name,
                overview: overview,
                description: description,
                tech_specs: techspecs,
                certification: certificates,
                parent_id: { _id: values.under_subcatId, name: categoryName },
                is_product: true,
                images_url: imageLists ? imageLists.map(fl => fl.response.data.url) : [],
                size_info: [visibleXS ? {size: "XS", ref_no: values.XS} : null, visibleS ? {size: "S", ref_no: values.S} : null, visibleM ? {size: "M", ref_no: values.M} : null,
                         visibleL ? {size: "L", ref_no: values.L} : null, visibleXL ? {size: "XL", ref_no: values.XL} : null],
                child: null
            })
        }else if(values.subcatId){ 
            productStore.createProduct({
                name: values.name,
                overview: overview,
                description: description,
                tech_specs: techspecs,
                certification: certificates,
                parent_id: { _id: values.subcatId, name: categoryName },
                is_product: true,
                images_url: imageLists ? imageLists.map(fl => fl.response.data.url) : [],
                size_info: [visibleXS ? {size: "XS", ref_no: values.XS} : null, visibleS ? {size: "S", ref_no: values.S} : null, visibleM ? {size: "M", ref_no: values.M} : null,
                        visibleL ? {size: "L", ref_no: values.L} : null, visibleXL ? {size: "XL", ref_no: values.XL} : null],
                child: null
            })

        }else if(values.parent){
            productStore.createProduct({
                name: values.name,
                overview: overview,
                description: description,
                tech_specs: techspecs,
                certification: certificates,
                parent_id: { _id: values.parent, name: categoryName },
                is_product: true,
                images_url: imageLists ? imageLists.map(fl => fl.response.data.url) : [],
                size_info: [visibleXS ? {size: "XS", ref_no: values.XS} : null, visibleS ? {size: "S", ref_no: values.S} : null, visibleM ? {size: "M", ref_no: values.M} : null,
                        visibleL ? {size: "L", ref_no: values.L} : null, visibleXL ? {size: "XL", ref_no: values.XL} : null],
                child: null                
            })
        }
    }

    return (
        <div>
            <PageHeader
                className="site-page-header"
                onBack={() => window.history.back()}
                title="Add Product"
                subTitle="Here you can Add Product"
            />
            <Divider />
            <Row>
                <Col span={24}>
                    <Form
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 14 }}
                        initialValues={{ remember: true }}
                        onFinish={formSubmit}
                    >
                        <Form.Item 
                            label="Name" 
                            name="name"
                            rules={[{
                                  required: true,
                                  message: 'Please enter product name!',
                            }]}
                        >
                            <Input placeholder="Enter Product Details" />
                        </Form.Item>
                        <Form.Item 
                            label="Overview" 
                            name="overview"
                            rules={[{
                                required: true,
                                message: 'Please enter overview!',
                            }]}
                        >
                            <CKEditor
                              editor={ ClassicEditor }
                              config={{ 
                                extraPlugins: [uploadPlugin] 
                              }}
                              data={over}
                              onReady={(editor) => {
                                // You can store the "editor" and use when it is needed.
                                // console.log("Editor is ready to use!", editor);
                                editor.editing.view.change((writer) => {
                                writer.setStyle(
                                    "height",
                                    "200px",
                                    editor.editing.view.document.getRoot()
                                );
                                });
                              }}
                              onChange={ ( event, editor ) => {
                                  const data = editor.getData();
                                  setOverview(data);
                                  console.log(overview);
                              } }
                          />
                        </Form.Item>
                        <Form.Item 
                            label="Description" 
                            name="description"
                            rules={[{
                                required: true,
                                message: 'Please enter description!',
                            }]}
                        >
                            <CKEditor
                              editor={ ClassicEditor }
                              config={{ 
                                extraPlugins: [uploadPlugin] 
                              }}
                              data={desc}
                              onReady={(editor) => {
                                // You can store the "editor" and use when it is needed.
                                // console.log("Editor is ready to use!", editor);
                                editor.editing.view.change((writer) => {
                                writer.setStyle(
                                    "height",
                                    "200px",
                                    editor.editing.view.document.getRoot()
                                );
                                });
                              }}
                              onChange={ ( event, editor ) => {
                                  const data = editor.getData();
                                  setDescription(data);
                                  console.log( { event, editor, data } );
                                  console.log(description);
                              } }
                          />
                        </Form.Item>
                        <Form.Item 
                            label="Technical Specs" 
                            name="technicalspecs"
                            rules={[{
                                required: true,
                                message: 'Please enter technical specs!',
                            }]}
                        >
                            <CKEditor
                              editor={ ClassicEditor }
                              config={{ 
                                extraPlugins: [uploadPlugin] 
                              }}
                              data={Tech}
                              onReady={(editor) => {
                                // You can store the "editor" and use when it is needed.
                                // console.log("Editor is ready to use!", editor);
                                editor.editing.view.change((writer) => {
                                writer.setStyle(
                                    "height",
                                    "200px",
                                    editor.editing.view.document.getRoot()
                                );
                                });
                              }}
                              onChange={ ( event, editor ) => {
                                  const data = editor.getData();
                                  setTechspecs(data);
                                  console.log(techspecs);
                              } }
                          />
                        </Form.Item> 
                        <Form.Item 
                            label="Certification" 
                            name="certificates"
                            rules={[{
                                required: true,
                                message: 'Please enter certification!',
                            }]}
                        >
                            <CKEditor
                              editor={ ClassicEditor }
                              config={{ 
                                extraPlugins: [uploadPlugin] 
                              }}
                              data={cert}
                              onReady={(editor) => {
                                // You can store the "editor" and use when it is needed.
                                // console.log("Editor is ready to use!", editor);
                                editor.editing.view.change((writer) => {
                                writer.setStyle(
                                    "height",
                                    "200px",
                                    editor.editing.view.document.getRoot()
                                );
                                });
                              }}
                              onChange={ ( event, editor ) => {
                                  const data = editor.getData();
                                  setCertificates(data);
                                  console.log(certificates);
                              } }
                          />
                        </Form.Item>
                        <div className="sizes-area">
                        <div className="ant-row ant-form-item ant-form-item-has-success" style={{rowGap: "0px"}}>
                            <div className="ant-col ant-col-4 ant-form-item-label">
                                <label>Sizes Info</label>
                            </div>
                        </div>   
                        <div className="ant-row ant-form-item ant-form-item-has-success" style={{rowGap: "0px"}}>
                            <div className="ant-col ant-col-4 ant-form-item-label">
                                <label>XS</label>
                            </div>
                            <div className="ant-col ant-col-1.5 ant-form-item-label">
                                <Switch onChange={(checked) => setVisibleXS(checked)} />
                            </div>
                            <div className="ant-col ant-col-6 ant-form-item-label" style={{margin: "0 0 0 10px"}}>
                                {visibleXS && (
                                <Form.Item name="XS">                                  
                                    <Input placeholder="Enter XS Reference No." />
                                </Form.Item>
                                )}
                            </div>
                        </div> 
                        <div className="ant-row ant-form-item ant-form-item-has-success" style={{rowGap: "0px"}}>
                            <div className="ant-col ant-col-4 ant-form-item-label">
                                <label>S</label>
                            </div>
                            <div className="ant-col ant-col-1.5 ant-form-item-label">
                                <Switch onChange={(checked) => setVisibleS(checked)} />
                            </div>
                            <div className="ant-col ant-col-6 ant-form-item-label" style={{margin: "0 0 0 10px"}}>
                                {visibleS && (
                                <Form.Item name="S">                                  
                                    <Input placeholder="Enter S Reference No." />
                                </Form.Item>
                                )}
                            </div>
                        </div>  
                        <div className="ant-row ant-form-item ant-form-item-has-success" style={{rowGap: "0px"}}>
                            <div className="ant-col ant-col-4 ant-form-item-label">
                                <label>M</label>
                            </div>
                            <div className="ant-col ant-col-1.5 ant-form-item-label">
                                <Switch onChange={(checked) => setVisibleM(checked)} />
                            </div>
                            <div className="ant-col ant-col-6 ant-form-item-label" style={{margin: "0 0 0 10px"}}>
                                {visibleM && (
                                <Form.Item name="M">                                  
                                    <Input placeholder="Enter M Reference No." />
                                </Form.Item>
                                )}
                            </div>
                        </div>  
                        <div className="ant-row ant-form-item ant-form-item-has-success" style={{rowGap: "0px"}}>
                            <div className="ant-col ant-col-4 ant-form-item-label">
                                <label>L</label>
                            </div>
                            <div className="ant-col ant-col-1.5 ant-form-item-label">
                                <Switch onChange={(checked) => setVisibleL(checked)} />
                            </div>
                            <div className="ant-col ant-col-6 ant-form-item-label" style={{margin: "0 0 0 10px"}}>
                                {visibleL && (
                                <Form.Item name="L">                                  
                                    <Input placeholder="Enter L Reference No." />
                                </Form.Item>
                                )}
                            </div>
                        </div> 
                        <div className="ant-row ant-form-item ant-form-item-has-success" style={{rowGap: "0px"}}>
                            <div className="ant-col ant-col-4 ant-form-item-label">
                                <label>XL</label>
                            </div>
                            <div className="ant-col ant-col-1.5 ant-form-item-label">
                                <Switch onChange={(checked) => setVisibleXL(checked)} />
                            </div>
                            <div className="ant-col ant-col-6 ant-form-item-label" style={{margin: "0 0 0 10px"}}>
                                {visibleXL && (
                                <Form.Item name="XL">                                  
                                    <Input placeholder="Enter XL Reference No." />
                                </Form.Item>
                                )}
                            </div>
                        </div> 
                        </div> 

                        <Form.Item 
                            label="Select Category" 
                            name="parent"
                            rules={[{
                                required: true,
                                message: 'Please Select category!',
                            }]}
                        >
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select Category"
                                onChange={(value, event) => {
                                    onSelectCategory(value, event)
                                    setCategoryName(categoryStore.getCategoryName(value))
                                }}
                            >
                                {categoryStore.categories && categoryStore.categories.map(cat => (
                                    <Option value={cat._id} key={cat._id}>{cat.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {subcategoryVisible &&
                            <Form.Item 
                                label="Select SubCategory"
                                name="subcatId"
                                rules={[{
                                    required: true,
                                    message: 'Please Select Subcategory!',
                                }]}
                            >
                                <Select
                                    placeholder="Select SubCategory"
                                    onChange={(value, event) => {
                                        onSelectSubCategory(value, event)
                                        setCategoryName(categoryStore.getCategoryName(value))
                                    }}
                                >
                                    {subCategoriesData.map(subcat => (
                                        <Option value={subcat._id} key={subcat._id}>{subcat.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        }
                        {under_subcategoryVisible &&
                            <Form.Item 
                                label="Select Under SubCategory"
                                name="under_subcatId"
                                rules={[{
                                    required: true,
                                    message: 'Please enter Under-subcategory!',
                                }]}
                            >
                                <Select
                                    placeholder="Select Under SubCategory"
                                    onChange={(value, event) => setCategoryName(categoryStore.getCategoryName(value))}
                                >
                                    {under_subCategoriesData.map(sub => (
                                        <Option value={sub._id} key={sub._id}>{sub.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        }
                        <Form.Item 
                            label="Images"
                            name="image"
                            rules={[{
                                required: true,
                                message: 'Please upload images!',
                            }]}
                        >
                            <Upload {...imageProps}>
                                <Button icon={<UploadOutlined />}>Multiple upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item wrapperCol={{ span: 14, offset: 4 }}>
                            <Button type="primary" htmlType="submit">Submit</Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default observer(AddProduct);
